import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { StepContainer } from '../../components/StepContainer/StepContainer';
import { StepFooter } from '../../components/StepFooter/StepFooter';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { FormValues, STEP_ID, validation } from './Donor.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { INPUTS_WIDTH } from '../../CharitableGiving.meta';
import { useNavigation } from '../../hooks/useNavigation';
import { WorkflowDTO } from '../../api/useCharitableGivingQuery';

export const Donor = () => {
  const { workflow, setWorkflow, setStep } = useCharitableGivingContext();

  const { progress, previousStep, nextStep, isFirstStep } = useNavigation({
    currentStep: STEP_ID,
  });

  const { control, handleSubmit, formState } = useForm<FormValues>({
    defaultValues: {
      donor: workflow.data.donor,
    },
    resolver: yupResolver(validation),
  });

  const onSubmit = handleSubmit(values => {
    const newWorkflow: WorkflowDTO = {
      ...workflow,
      data: {
        ...workflow.data,
        donor: values.donor,
      },
    };

    setWorkflow(newWorkflow);

    if (nextStep) {
      setStep(nextStep);
    }
  });

  const { donorOptions } = workflow.options;

  return (
    <StepContainer
      title="Who is making the donation?"
      onSubmit={onSubmit}
      footer={
        <StepFooter
          isFirstStep={isFirstStep}
          progress={progress}
          onPrevious={previousStep ? () => setStep(previousStep) : undefined}
        />
      }
    >
      <Controller
        control={control}
        name="donor"
        render={({ field: { value: formValue, onChange, ref } }) => (
          <Box style={{ width: INPUTS_WIDTH }}>
            <Select
              innerRef={ref}
              label="Donor"
              value={donorOptions.find(({ value }) => value === formValue)}
              onChange={opt => onChange(opt?.value)}
              options={donorOptions}
              formVariant={formState.errors.donor ? 'error' : undefined}
              helperText={formState.errors.donor?.message}
            />
          </Box>
        )}
      />
    </StepContainer>
  );
};
